import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { AppState } from 'src/app/store/app.states';
import { ComponentBase } from 'src/app/views/component-base';
import { commonState_IsSending, commonState_LatestJourney } from 'src/app/store/common/common.selectors';
import { GoToStepAction, SignupCompletedAction } from '../../actions';
import { AppButtonComponent, Helper } from '@ifaa-components/ui-components';
import { review_DataSaved } from './selectors';
import { AsyncPipe, DatePipe, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { details_Form, details_Genders } from '../nmj-details/selectors';
import { investments_FormInvestmentOptions } from '../nmj-investments/selectors';
import { rollin_Form } from '../nmj-rollin/selectors';
import { combineLatest } from 'rxjs';
import { ReviewDataModel } from './state';
import { InvestmentReviewCardComponent } from '../../../../components/investment-review-card/investment-review-card.component';
import { RollinReviewCardComponent } from '../../../../components/rollin-review-card/rollin-review-card.component';
import { CompleteRequestAction } from './actions';
import { initialData_Form } from '../nmj-initial-data/selectors';


@Component({
    selector: 'app-nmj-review',
    templateUrl: './nmj-review.component.html',
    styleUrls: ['./nmj-review.component.scss'],
    imports: [
        AppButtonComponent,
        AsyncPipe,
        NgTemplateOutlet,
        NgIf,
        NgFor,
        InvestmentReviewCardComponent,
        RollinReviewCardComponent,
        DatePipe
    ],
})
export class NmjReviewComponent extends ComponentBase implements OnInit, OnDestroy {

    @Input() set step(value: number) {
        this.stepIndex = value;
    }

    isLoading$ = this.store.pipe(select(commonState_IsSending));
    journeySteps$ = this.store.pipe(select(commonState_LatestJourney));
    dataSaved$ = this.store.pipe(select(review_DataSaved));

    initialDetails$ = this.store.pipe(select(initialData_Form));
    personalDetailsForm$ = this.store.pipe(select(details_Form));
    investmentOptionsForm$ = this.store.pipe(select(investments_FormInvestmentOptions));
    rollinForm$ = this.store.pipe(select(rollin_Form));
    genders$ = this.store.pipe(select(details_Genders));

    helper: Helper = new Helper();
    stepIndex: number = 0;
    nextStep: number = 0;
    previousStep: number = 0;

    genderText: string = '';

    personalDetailsStepIndex: number = 0;
    investmentOptionsStepIndex: number = 0;
    rollinStepIndex: number = 0;

    reviewDetails: ReviewDataModel = null;

    constructor(
        public store: Store<AppState>
    ) {
        super();
    }

    async ngOnInit() {
        super.ngOnInitBase();
        window.scrollTo(0, 0);

        this.sub = this.journeySteps$.subscribe(async x => {
            if (x) {
                var journeySteps = await this.helper.getValue(this.journeySteps$);

                if (journeySteps) {
                    this.nextStep = journeySteps.journeySteps.filter(x => x.journeyStep > this.stepIndex)[0]?.journeyStep ?? -1;
                    this.previousStep = journeySteps.journeySteps.filter(x => x.journeyStep < this.stepIndex).sort((a, b) => b.journeyStep - a.journeyStep)[0]?.journeyStep;

                    this.personalDetailsStepIndex = journeySteps.journeySteps.find(x => x.journeyStepName === "Details")?.journeyStep;
                    this.investmentOptionsStepIndex = journeySteps.journeySteps.find(x => x.journeyStepName === "Investment options")?.journeyStep;
                    this.rollinStepIndex = journeySteps.journeySteps.find(x => x.journeyStepName === "Superannuation Rollin")?.journeyStep;
                }
            }
        })

        this.sub = this.dataSaved$.subscribe(async x => {
            if (x) {
                this.store.dispatch(SignupCompletedAction());
            }
        })

        this.sub = combineLatest({
            genderValues: this.genders$,
            personalDetails: this.personalDetailsForm$
        })
            .subscribe(({ genderValues, personalDetails }) => {
                if (genderValues && personalDetails?.value){
                    var gender = genderValues.find(x => x.key == personalDetails.value.gender);
                    this.genderText = gender.value;
                }
            })

        this.sub = combineLatest({
            personalDetails: this.personalDetailsForm$,
            initialDetails: this.initialDetails$,
            investmentOptions: this.investmentOptionsForm$,
            rollins: this.rollinForm$
        })
            .subscribe(({ personalDetails, initialDetails, investmentOptions, rollins }) => {
                this.reviewDetails = {
                    initialDetails: initialDetails?.value,
                    personalDetails: personalDetails?.value,
                    investmentOptions: investmentOptions?.value.filter(x => x.percentage > 0),
                    rollins: rollins?.value.superFundList.filter(x => x.usi)
                }
            });
    }

    ngOnDestroy(): void {
        super.ngOnDestroyBase();
    }

    async onMoveBackClick() {
        this.store.dispatch(GoToStepAction({ index: this.previousStep }))
    }

    async onCompleteClick() {
        if (await this.helper.getValue(this.isLoading$)) return;

        var form = await this.helper.getValue(this.rollinForm$);

        var data = await this.helper.clone(form.value);

        data.superFundList = data.superFundList.filter(x => x.memberNumber);

        this.store.dispatch(CompleteRequestAction({ data: data }));
    }

    navigatePersonalDetails() {
        this.store.dispatch(GoToStepAction({ index: this.personalDetailsStepIndex }))
    }

    navigateInvestmentOptions() {
        this.store.dispatch(GoToStepAction({ index: this.investmentOptionsStepIndex }))
    }

    navigateRollin() {
        this.store.dispatch(GoToStepAction({ index: this.rollinStepIndex }))
    }
}
